import { FC, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Formik } from 'formik'
import { format } from 'date-fns'
import { Grid } from '@mui/material'
import { usePOST_generalNoteMutation } from 'redux/api/generalNotesApi'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import RichTextField from 'components/atoms/fields/RichTextField'
import DateTimePickerField from 'components/atoms/fields/DateTimePickerField'
import InputField from 'components/atoms/fields/InputField'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'
import formModel, { initialValues, validationSchema } from 'utils/formModels/generalNoteModel'
import SelectField from 'components/atoms/fields/SelectField'
import { useGET_studentsProfileSelectQuery } from 'redux/api/studentsApi'
import { useGET_assignmentByIdQuery } from 'redux/api/assignmentsApi'


interface IProps {
  assignmentId?: string
  onCreate?: any
}

const GeneralNoteForm: FC<IProps> = ({ assignmentId, onCreate }) => {
  const { t } = useTranslation()

  const { data: assignmentData } = useGET_assignmentByIdQuery(assignmentId, {
    skip: !assignmentId,
  })

  const { title, text, show_from_datetime, show_to_datetime, recipients } = formModel()

  const [
    addEntity,
    { isLoading: createLoading, isSuccess: createSuccess, error: createError, data: addResponseData },
  ] = usePOST_generalNoteMutation()

  useErrorAlert(createError)
  useSuccessAlert(createSuccess ? t('alerts.message-sent') : '')

  useEffect(() => {
    if(createSuccess)
      onCreate();
  }, [createSuccess])


  return (
    assignmentData && <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: any) => {
        addEntity({ assignment_id: assignmentId, body: { 
         ...values,
         show_from_datetime: values.show_from_datetime.replace(' ', 'T'),
         show_to_datetime: values.show_to_datetime.replace(' ', 'T'),
         recipients_ids: values.recipients.map(r => r.id)
        } })
      }}
    >
      {({ values}) => {
        return (
          <Form>
            <Grid container spacing={3} sx={{ marginTop: '0px' }}>
              <Grid item xs={12}>
                <InputField fieldProps={{ ...title }} />
              </Grid>
              <Grid item xs={12}>
                <RichTextField
                  width={'100%'}
                  fieldProps={{...text}}
                  label={text.label}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DateTimePickerField fieldProps={{ ...show_from_datetime }} />
              </Grid>
              <Grid item xs={12} md={6}>
                <DateTimePickerField fieldProps={{ ...show_to_datetime }} />
              </Grid>
              <Grid item xs={12} md={12}>
                <SelectField
                  multiple={true}
                  fieldProps={{ ...recipients }}
                  apiCall={useGET_studentsProfileSelectQuery}
                  filters={{ group_course: assignmentData?.group_course?.id }}
                />
              </Grid>
              <Grid item xs={12}>
                <SubmitButton
                  color={'success'}
                  text={`${t('common.save')}`}
                  sx={{ width: '150px', marginTop: '20px' }}
                  isLoading={createLoading}
                  alignRight={false}
                />
              </Grid>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}

export default GeneralNoteForm
